import type { editor, languages } from 'monaco-editor'

import type { LanguageWorkerAccessor, WorkerMapping } from '../worker/api'

export class FPlusFormattingProvider<T>
  implements languages.DocumentFormattingEditProvider
{
  private worker: LanguageWorkerAccessor<T>
  private asWorkerInput: WorkerMapping<T>

  constructor(
    worker: LanguageWorkerAccessor<T>,
    asWorkerInput: WorkerMapping<T>,
  ) {
    this.worker = worker
    this.asWorkerInput = asWorkerInput
  }

  provideDocumentFormattingEdits(
    model: editor.ITextModel,
  ): languages.ProviderResult<languages.TextEdit[]> {
    return this.format(model)
  }

  private async format(
    model: editor.ITextModel & { FORMATTINGWIDTH?: number },
  ): Promise<languages.TextEdit[]> {
    const worker = await this.worker(model.uri)

    if (!worker) {
      return []
    }

    const input = await this.asWorkerInput({ model })

    if (!input?.data) {
      return []
    }

    const width = model.FORMATTINGWIDTH
    const formattedCode = await worker.format(input.data, width)

    return [
      {
        text: formattedCode.content[0],
        range: {
          endColumn: Number.MAX_SAFE_INTEGER,
          endLineNumber: Number.MAX_SAFE_INTEGER,
          startColumn: 0,
          startLineNumber: 0,
        },
      },
    ]
  }
}
